import './index.scss'
import '@fancyapps/fancybox/dist/jquery.fancybox.min'
import Swiper from 'swiper/swiper-bundle.min.js'
var honor = new Swiper(".section4 .mySwiper", {
    slidesPerView: 3,
    slidesPerGroup: 3,
    spaceBetween: 25,
    loop:true,
    navigation: {
        nextEl: ".section4  .swiper-button-next",
        prevEl: ".section4  .swiper-button-prev",
    },
    breakpoints: {
      1280: {  //当屏幕宽度小于等于1280
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 25,
      },
      768: {  //当屏幕宽度小于等于768
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 25,
      },
      320: {  //当屏幕宽度小于等于320
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0,
      }
    } 
});